import { render, staticRenderFns } from "./CapitalGoodsInvoice.vue?vue&type=template&id=54465d73&"
import script from "./CapitalGoodsInvoice.vue?vue&type=script&lang=js&"
export * from "./CapitalGoodsInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports